import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SectionTitle from '../common/SectionTitle';
import Card from '../common/Card';
import { staggerContainer, staggerItem } from '../../utils/animations';
import { MENU_ITEMS } from '../../utils/constants';

const ServicesGrid = () => {
  const navigate = useNavigate();

  const handleServiceClick = (path) => {
    navigate(path);
  };

  // Map service icons to their image paths
  const getServiceIcon = (title) => {
    const iconMap = {
      'Industrial': '/images/industrial_icon.png',
      'Commercial': '/images/commercial_icon.png',
      'Residential': '/images/residential_icon.png'
    };
    return iconMap[title] || null;
  };

  return (
    <section id="services" className="py-20 bg-accent-cream">
      <div className="container mx-auto px-4">
        {/* Services Categories */}
        <SectionTitle
          title="Our Services"
          subtitle="What We Offer"
          align="center"
        />

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {MENU_ITEMS.map((category, index) => (
            <Card 
              key={category.id} 
              hoverable={true}
              delay={index * 0.1}
            >
              <Card.Content className="p-8 text-center">
                {/* Icon */}
                <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                  <img
                    src={getServiceIcon(category.title)}
                    alt={`${category.title} icon`}
                    className="w-full h-full object-contain"
                  />
                </div>

                <Card.Title className="mb-4 text-center">
                  {category.title}
                </Card.Title>

                {/* Services List */}
                <div className="space-y-3 mb-6">
                  {category.services.map((service, idx) => (
                    <div 
                      key={service.id}
                      className="text-sm text-dark-light py-2 border-b border-primary-beige last:border-0"
                    >
                      {service.title}
                    </div>
                  ))}
                </div>

                <motion.button
                  onClick={() => handleServiceClick(category.path)}
                  className="text-primary-brown font-medium hover:text-dark transition-colors"
                  whileHover={{ x: 5 }}
                >
                  View Details →
                </motion.button>
              </Card.Content>
            </Card>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesGrid;